import { Link } from 'react-router-dom'
import logo from '../../../assets/images/logo.png'
import mailboxIllustration from '../../../assets/images/verify-email-mailbox.png'
import './check-email.page.css'

type CheckEmailViewProps = {
  email: string
}

const CheckEmailView = ({ email }: CheckEmailViewProps) => {
  return (
    <div className="check-email-page">
      <div className="check-email-container">
        <img src={logo} alt="Transpots Logo" className="check-email-logo" />

        <img
          src={mailboxIllustration}
          alt="Mailbox with verification email"
          className="check-email-illustration"
        />

        <h1 className="check-email-title">Check Your Email</h1>

        <p className="check-email-message">
          We&apos;ve sent a verification link to
          <br />
          <strong>{email}</strong>.
          <br />
          Please check your inbox and click the link to verify your account.
        </p>

        <hr className="check-email-divider" />

        <p className="check-email-hint">
          Didn&apos;t receive the email? Check your spam folder.
        </p>

        <Link to="/auth/login" className="check-email-back-button">
          Back to Sign In
        </Link>
      </div>
    </div>
  )
}

export default CheckEmailView
